import { render, staticRenderFns } from "./PriceQuote.vue?vue&type=template&id=63bd8578&"
import script from "./PriceQuote.vue?vue&type=script&lang=js&"
export * from "./PriceQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports